import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { EnglishScreen } from '../../features/personal/EnglishScreen';

/**
 * `/personal/english` = قسم الإنجليزية (طلب المالك في `FLOW MCP.docx`).
 *
 * النصّ المفتوح وجلسةُ المراجعة في `?text=` و`?review=` لا في الحالة: رابطٌ
 * يُنسخ يفتح ما فُتح، وزرّ الرجوع في الجوال يخرج من القارئ إلى القائمة بدل أن
 * يخرج من القسم كلّه — وهو أوّل ما يُجرَّب على الجوال.
 *
 * **وتحذير مقيس** (سابقة `personal/archive.tsx`): خادم التطوير العامل يولّد
 * ملف المسار الجديد بقالبٍ افتراضي إن رآه ناقصًا لحظة الكتابة فيدهس ما كُتب.
 * فبعد الإنشاء: اقرأه، أو ابنِ وابحث عن نصٍّ من شاشتك.
 */
export const Route = createFileRoute('/personal/english')({
  /*
   * `review` تُقرأ **رقمًا لا نصًّا** — مقيسٌ في المتصفّح لا مُخمَّن.
   *
   * محلّل الاستعلام في TanStack يمرّر القيم على `JSON.parse`، فـ`?review=1`
   * تصل عددًا `1` بينما `?text=01K…` تبقى نصًّا لأنها ليست JSON صالحة. فشرطٌ
   * على `'1'` النصّية يمرّ **صامتًا**: الرابط يتغيّر في شريط العنوان والشاشة
   * لا تتغيّر — وقد وقع ذلك هنا فعلًا، ولم يكشفه المُصرِّف ولا اختبارٌ.
   *
   * والعلاج قبولُ الاثنين لا واحدًا: الرابط قد يُكتب بيده أيضًا.
   */
  validateSearch: (search: Record<string, unknown>): { text?: string; review?: boolean } => ({
    ...(typeof search['text'] === 'string' ? { text: search['text'] } : {}),
    ...(search['review'] === true || search['review'] === 1 || search['review'] === '1'
      ? { review: true }
      : {}),
  }),
  component: EnglishRoute,
});

function EnglishRoute() {
  const { text, review } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <EnglishScreen
      openTextId={text ?? null}
      reviewing={review === true}
      onOpenText={(id) => {
        void navigate({ search: id === null ? {} : { text: id } });
      }}
      onReview={(on) => {
        void navigate({ search: on ? { review: true } : {} });
      }}
    />
  );
}
